import { FC } from 'react';
import { IonButtons, IonContent } from '@ionic/react';
import { AllieText } from '../../../components';
import {
  InfoUserWrapper,
  AllieHeaderStyled,
  StyledToolbar,
  ContentHeaderButton,
  HeaderButtonDesktop,
  StyledToggleMenuButton,
  StyledLogoContainer,
} from './components/Header.styles';
import { AvatarInfo } from './components/AvatarInfo';
import { ListOptionsMenu } from './components/ListOptionsMenu';
import { SpectatorMode } from './components/SpectatorMode';
import { AllieMenuLogoIcon, AllieMessageQuestionCircleIcon } from '../../../styling/icons';
import { HeaderMobileProps } from './Header.types';
import { isMobile } from '../../../common/utils';

const AllieHeaderMobile: FC<HeaderMobileProps> = ({
  isAuthenticated,
  color,
  optionsMenuAvatar,
  loggedUser,
  onClickLogin,
  textLogin,
  messageLogin,
  imgLogo,
  helpLabel,
  showHelp = true,
  onHelpClick,
  currentLanguage,
  onLanguageChange,
  languages,
  languageLabel,
  hasNotification,
  contentButtonMenu,
  isTestEnv,
}) => {
  return (
    <AllieHeaderStyled mode="md" color={'menu'} isMobile={isMobile}>
      <StyledToolbar mode="md">
        <IonButtons slot="start" style={{ marginLeft: '8px' }}>
          {contentButtonMenu ?? (
            <StyledToggleMenuButton
              {...(color ? { color: 'light' } : {})}
              menu="sidebar-menu"
              mode="md"
              style={{ height: 40, width: 40 }}
              autoHide={false}
              hasNotification={hasNotification}
            />
          )}
        </IonButtons>
        <StyledLogoContainer>
          <AllieMenuLogoIcon
            display="contents"
            height={32}
            width={90}
            allieColor="white"
            showTest={isTestEnv}
          />
        </StyledLogoContainer>
        <InfoUserWrapper slot="end" isMobile={isMobile}>
          {isAuthenticated ? (
            <>
              {showHelp && (
                <HeaderButtonDesktop
                  id="intercom-button"
                  allieSize="xs"
                  allieType="subtle"
                  corner="rounded-edges-plus"
                  onClick={onHelpClick}
                >
                  <ContentHeaderButton>
                    <AllieMessageQuestionCircleIcon />
                    <AllieText type="body3" color="neutral-30">
                      {helpLabel}
                    </AllieText>
                  </ContentHeaderButton>
                </HeaderButtonDesktop>
              )}
              <AvatarInfo
                optionsMenuAvatar={optionsMenuAvatar as any}
                loggedUser={loggedUser}
                isMobile
              >
                <IonContent>
                  <AllieText type="body3" color="neutral-70" style={{ padding: '0 1rem' }}>
                    {loggedUser?.name}
                  </AllieText>
                  <ListOptionsMenu
                    options={optionsMenuAvatar as any}
                    currentLanguage={currentLanguage}
                    onLanguageChange={onLanguageChange}
                    languages={languages}
                    languageLabel={languageLabel}
                  />
                </IonContent>
              </AvatarInfo>
            </>
          ) : (
            <SpectatorMode
              onClick={onClickLogin}
              labels={{ message: messageLogin, login: textLogin }}
              platform="mobile"
            />
          )}
        </InfoUserWrapper>
      </StyledToolbar>
    </AllieHeaderStyled>
  );
};

export default AllieHeaderMobile;
